'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOGGLE_PRIVACY = exports.REMOVE_CONTENT = exports.MOVE_CONTENT = exports.ADD_CONTENT = exports.TOGGLE_PRIVACY_EVENT = exports.REMOVE_FROM_SHELF = exports.MOVE_TO_SHELF = exports.ADD_TO_SHELF = exports.SHELVES = undefined;
exports.composeShelfEvent = composeShelfEvent;
exports.composeAddToShelfEvent = composeAddToShelfEvent;
exports.composeRemoveFromShelfEvent = composeRemoveFromShelfEvent;
exports.composeUpdateShelfEvent = composeUpdateShelfEvent;

var _constantsAnalytics = require('@bibliocommons/constants-analytics');

var _constantsAnalytics2 = _interopRequireDefault(_constantsAnalytics);

var _compose = require('./compose');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHELVES = exports.SHELVES = _constantsAnalytics2.default.CATEGORIES.SHELVES;
var _analyticsConstants$E = _constantsAnalytics2.default.EVENTS;
var ADD_TO_SHELF = _analyticsConstants$E.ADD_TO_SHELF,
    MOVE_TO_SHELF = _analyticsConstants$E.MOVE_TO_SHELF,
    REMOVE_FROM_SHELF = _analyticsConstants$E.REMOVE_FROM_SHELF,
    TOGGLE_PRIVACY_EVENT = _analyticsConstants$E.TOGGLE_PRIVACY_EVENT;
exports.ADD_TO_SHELF = ADD_TO_SHELF;
exports.MOVE_TO_SHELF = MOVE_TO_SHELF;
exports.REMOVE_FROM_SHELF = REMOVE_FROM_SHELF;
exports.TOGGLE_PRIVACY_EVENT = TOGGLE_PRIVACY_EVENT;
var _analyticsConstants$A = _constantsAnalytics2.default.ACTIONS;
var ADD_CONTENT = _analyticsConstants$A.ADD_CONTENT,
    MOVE_CONTENT = _analyticsConstants$A.MOVE_CONTENT,
    REMOVE_CONTENT = _analyticsConstants$A.REMOVE_CONTENT,
    TOGGLE_PRIVACY = _analyticsConstants$A.TOGGLE_PRIVACY;
exports.ADD_CONTENT = ADD_CONTENT;
exports.MOVE_CONTENT = MOVE_CONTENT;
exports.REMOVE_CONTENT = REMOVE_CONTENT;
exports.TOGGLE_PRIVACY = TOGGLE_PRIVACY;
function composeShelfEvent(eventName, metadataIds, shelfName, action) {
  return (0, _compose.composeEvent)(eventName, {
    gtmValue: metadataIds.length,
    gtmLabel: shelfName,
    gtmCategory: SHELVES,
    gtmAction: action,
    metadataIds: metadataIds
  });
}

function composeAddToShelfEvent(metadataIds, shelfName) {
  return (0, _compose.composeAnalytics)([composeShelfEvent(ADD_TO_SHELF, metadataIds, shelfName, ADD_CONTENT)]);
}

function composeRemoveFromShelfEvent(metadataIds, shelfName) {
  return (0, _compose.composeAnalytics)([composeShelfEvent(REMOVE_FROM_SHELF, metadataIds, shelfName, REMOVE_CONTENT)]);
}

function composeUpdateShelfEvent(metadataIds, fromShelfName, toShelfName, toPrivateItem) {
  var events = [];

  if (fromShelfName && toShelfName && fromShelfName !== toShelfName) {
    events.push(composeShelfEvent(MOVE_TO_SHELF, metadataIds, toShelfName, MOVE_CONTENT));
  }

  if (toPrivateItem !== undefined && toPrivateItem !== null) {
    var label = toPrivateItem ? 'private' : 'public';
    events.push(composeShelfEvent(TOGGLE_PRIVACY_EVENT, metadataIds, label, TOGGLE_PRIVACY));
  }

  return (0, _compose.composeAnalytics)(events);
}

exports.default = {
  composeShelfEvent: composeShelfEvent,
  composeAddToShelfEvent: composeAddToShelfEvent,
  composeRemoveFromShelfEvent: composeRemoveFromShelfEvent,
  composeUpdateShelfEvent: composeUpdateShelfEvent
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/analytics-event-composers/lib/shelvesEventComposer.js
// module id = 459
// module chunks = 0 2 4 5 6 8 9 10 11